export default __webpack_public_path__ + "static/media/icon-add.062950d7.svg";